import { useQuery } from '@tanstack/react-query';

import { fetchFeatureFlags, type FeatureFlags } from '../lib/feature-flags';

export const FEATURE_FLAGS_QUERY_KEY = ['feature_flags'] as const;
const FIVE_MINS_IN_MS = 5 * 60 * 1000;
const TEN_MINS_IN_MS = 10 * 60 * 1000;
const NO_FLAGS: FeatureFlags = {};

export type UseFeatureFlagsResult = {
  /** Empty while loading and after an error, so every flag reads as off. */
  flags: FeatureFlags;
  isLoading: boolean;
  error: Error | null;
};

/** @param baseUrl subscription-manager base URL. Each app supplies its own configured value. */
export function useFeatureFlags(baseUrl: string): UseFeatureFlagsResult {
  const { data, error, isPending } = useQuery({
    queryKey: FEATURE_FLAGS_QUERY_KEY,
    queryFn: () => fetchFeatureFlags(baseUrl),
    staleTime: FIVE_MINS_IN_MS,
    gcTime: TEN_MINS_IN_MS,
  });

  return { flags: data ?? NO_FLAGS, isLoading: isPending, error };
}
